import { useSelector } from "react-redux";
import { isAuthSelector } from "../redux/slices/auth";
import { Link, Navigate } from "react-router-dom";
import { Context } from "../Context";
import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import Cookies from "js-cookie";

const infoPrice = [
  {
    packageName: "Free Package",
    price: "0",
    amount: "10 prompts",
    descr: "Get started with our Free Plan and explore the basics",
  },
  ,
  {
    packageName: "Basic Package",
    price: "11.99",
    amount: "100 prompts",
    descr: "Our $11.99 package offers essential features for those on a budget",
  },
  {
    packageName: "Intermediate Package",
    price: "29.99",
    amount: "300 prompts",
    descr:
      "Upgrade to our $29.99 package and unlock advanced tools and resources",
  },
  {
    packageName: "Advanced Package",
    price: "54.99",
    amount: "600 prompts",
    descr:
      "Experience premium performance and features with our $54.99 package",
  },
  {
    packageName: "Max Package",
    price: "109.99",
    amount: "1200 prompts",
    descr: "Unlock the ultimate experience with our $109.99 package",
  },
  {
    packageName: "Vip Package",
    price: "199.99",
    amount: "2000 prompts",
    descr: "Experience unparalleled excellence with our $199.00 package",
  },
];

const container = {
  hidden: { opacity: 1, scale: 0 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      delayChildren: 0.1,
      staggerChildren: 0.15,
    },
  },
};

const item = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  },
};

export const PaymentPrompts = () => {
  const { paymentSum, userData } = React.useContext(Context);
  const [loader, setLoader] = useState(true);
  const checkAuth = useSelector(isAuthSelector);

  const checkoutStripe = async () => {
    try {
      setLoader(false);
      const { data } = await axios.post(
        `${process.env.REACT_APP_LINK_API_BACKEND}create-checkout-session`,
        {
          items: [
            {
              id: 1,
              quantity: 1,
              price: paymentSum ? infoPrice[paymentSum].price : "11.99",
              name: "Top up your balance on flxart",
            },
          ],
          promptsId: paymentSum,
          email: userData.email,
        }
      );
      const { url } = data;
      window.location = url;
    } catch (error) {
      console.log(error);
    }
  };
  const checkoutPayPal = async () => {
    try {
      setLoader(false);
      const { data } = await axios.post(
        `${process.env.REACT_APP_LINK_API_BACKEND}paypal/create-payment`,
        {
          price: infoPrice[paymentSum].price,
          email: userData.email,
          promptsId: paymentSum,
        }
      );
      const { url } = data;
      window.location = url;
    } catch (error) {
      console.log(error);
    }
  };
  if (!checkAuth) {
    return <Navigate to="/Login" />;
  }

  const container = {
    hidden: { opacity: 1, scale: 0 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        delayChildren: 0.1,
        staggerChildren: 0.15,
      },
    },
  };

  return (
    <>
      <motion.div
        variants={container}
        animate="visible"
        initial="hidden"
        className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0"
      >
        {loader ? (
          <div className="relative flex min-h-screen flex-col justify-center overflow-hidden  py-6 sm:py-12">
            <div className="absolute inset-0  bg-center [mask-image:linear-gradient(180deg,white,rgba(255,255,255,0))]"></div>
            <div className="relative bg-gray-800 px-6 pt-10 pb-8 shadow-xl ring-1 ring-gray-900/5 sm:mx-auto sm:max-w-lg sm:rounded-lg sm:px-10">
              <div className="mx-auto max-w-md">
                <h1 className="text-2xl text-white">Payment </h1>
                <div className="divide-y divide-gray-300/50">
                  <h2 className="mr-2 text-5xl font-extrabold my-3 text-white">
                    ${paymentSum ? infoPrice[paymentSum].price : "11.99$"}
                  </h2>
                  <div className="py-8 text-base leading-7 text-gray-600">
                    <ul className="space-y-4">
                      <li className="flex items-center">
                        <svg
                          className="flex-shrink-0 w-5 h-5  text-green-400"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clip-rule="evenodd"
                          ></path>
                        </svg>
                        <p className="ml-4 text-white">
                          Depositing {infoPrice[paymentSum].amount} into your
                          account
                        </p>
                      </li>
                    </ul>
                  </div>
                  <div className="pt-4 text-base font-semibold leading-7">
                    <p className="pt-4 text-white">
                      Choose what you want to pay through:
                    </p>
                    <li className="flex items-center justify-between">
                      <div className="flex">
                        <svg
                          onClick={() => checkoutStripe()}
                          className="cursor-pointer"
                          width="87"
                          height="50"
                          viewBox="0 0 87 50"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            width="87"
                            height="49.7143"
                            rx="9.32143"
                            fill="#6461FC"
                          />
                          <path
                            d="M46.2005 14.6533L41.6511 15.6584V11.8615L46.2005 10.875V14.6533Z"
                            fill="white"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M55.6615 16.7565C53.8852 16.7565 52.7433 17.6127 52.109 18.2083L51.8733 17.0543H47.8858V38.7565L52.4171 37.77L52.4352 32.5027C53.0877 32.9866 54.0483 33.6753 55.6433 33.6753C58.8877 33.6753 61.8421 30.9951 61.8421 25.0949C61.824 19.6973 58.8333 16.7565 55.6615 16.7565ZM54.5739 29.5805C53.5045 29.5805 52.8701 29.1896 52.4351 28.7057L52.417 21.8005C52.8883 21.2607 53.5408 20.8885 54.5739 20.8885C56.2233 20.8885 57.3651 22.787 57.3651 25.2252C57.3651 27.7193 56.2414 29.5805 54.5739 29.5805Z"
                            fill="white"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M76.125 25.281C76.125 20.5162 73.8775 16.7565 69.5819 16.7565C65.2681 16.7565 62.6581 20.5162 62.6581 25.2438C62.6581 30.8462 65.7394 33.6753 70.1619 33.6753C72.3188 33.6753 73.95 33.1727 75.1825 32.4655V28.743C73.95 29.3758 72.5363 29.7666 70.7419 29.7666C68.9838 29.7666 67.425 29.1338 67.2256 26.9375H76.0888C76.0888 26.835 76.0953 26.6019 76.1028 26.3334C76.113 25.9686 76.125 25.5384 76.125 25.281ZM67.1713 23.5129C67.1713 21.4097 68.4219 20.5349 69.5638 20.5349C70.6694 20.5349 71.8475 21.4097 71.8475 23.5129H67.1713Z"
                            fill="white"
                          />
                          <path
                            d="M41.6511 17.073H46.2005V33.3589H41.6511V17.073Z"
                            fill="white"
                          />
                          <path
                            d="M36.4858 17.073L36.7758 18.4503C37.8451 16.4401 39.9658 16.8496 40.5458 17.073V21.3538C39.9839 21.1491 38.1714 20.8885 37.102 22.3217V33.3589H32.5708V17.073H36.4858Z"
                            fill="white"
                          />
                          <path
                            d="M27.713 13.034L23.2905 14.0019L23.2724 28.9105C23.2724 31.6651 25.2843 33.6939 27.9668 33.6939C29.453 33.6939 30.5405 33.4147 31.1387 33.0797V29.3013C30.5587 29.5433 27.6949 30.3995 27.6949 27.6448V21.0374H31.1387V17.0729H27.6949L27.713 13.034Z"
                            fill="white"
                          />
                          <path
                            d="M17.0013 20.7955C16.0406 20.7955 15.4606 21.0747 15.4606 21.8006C15.4606 22.5931 16.4588 22.9417 17.6972 23.3743C19.716 24.0794 22.3732 25.0074 22.3844 28.4452C22.3844 31.7768 19.7925 33.6939 16.0225 33.6939C14.4638 33.6939 12.76 33.3775 11.0744 32.633V28.2032C12.5969 29.0594 14.5181 29.6922 16.0225 29.6922C17.0375 29.6922 17.7625 29.4131 17.7625 28.5569C17.7625 27.679 16.6805 27.2777 15.3741 26.7933C13.3846 26.0555 10.875 25.1248 10.875 22.0239C10.875 18.7295 13.3219 16.7566 17.0013 16.7566C18.5056 16.7566 19.9919 16.9985 21.4963 17.6127V21.9867C20.1188 21.2236 18.3788 20.7955 17.0013 20.7955Z"
                            fill="white"
                          />
                          <rect
                            x="0.776786"
                            y="0.776786"
                            width="85.4464"
                            height="48.1607"
                            rx="8.54464"
                            stroke="black"
                            stroke-opacity="0.14"
                            stroke-width="1.55357"
                          />
                        </svg>
                        <svg
                          onClick={checkoutPayPal}
                          className="ml-5 cursor-pointer"
                          width="87"
                          height="50"
                          viewBox="0 0 87 50"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            width="87"
                            height="49.7143"
                            rx="6"
                            fill="#003087"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M22.4459 16.42C21.5891 15.831 20.471 15.5358 19.0917 15.5358H13.7518C13.329 15.5358 13.0954 15.7472 13.051 16.1698L10.8818 29.7863C10.8593 29.92 10.8927 30.0423 10.9819 30.1535C11.0705 30.2649 11.182 30.3203 11.3156 30.3203H13.852C14.2969 30.3203 14.5414 30.1094 14.5863 29.6863L15.1869 26.0153C15.2089 25.8374 15.2871 25.6928 15.4206 25.5814C15.5541 25.4702 15.721 25.3974 15.9212 25.3642C16.1215 25.3311 16.3103 25.3144 16.4886 25.3144C16.6664 25.3144 16.8777 25.3257 17.1228 25.3479C17.3673 25.37 17.5232 25.3809 17.59 25.3809C19.5034 25.3809 21.0052 24.8418 22.0956 23.7623C23.1855 22.6834 23.731 21.1873 23.731 19.2734C23.731 17.9607 23.3023 17.0096 22.4459 16.4197V16.42ZM19.6927 20.5086C19.5811 21.2875 19.2922 21.799 18.825 22.0438C18.3577 22.2889 17.6902 22.4109 16.8226 22.4109L15.7212 22.4442L16.2886 18.8731C16.3329 18.6286 16.4775 18.5061 16.7224 18.5061H17.3567C18.2463 18.5061 18.8919 18.6344 19.2924 18.8898C19.6927 19.1459 19.8262 19.6856 19.6927 20.5086ZM48.9618 20.9094C48.9617 20.7984 48.917 20.6926 48.8286 20.5927C48.7394 20.4927 48.6392 20.4423 48.5282 20.4423H45.9584C45.7132 20.4423 45.5129 20.5541 45.3574 20.7759L41.8199 25.9825L40.3514 20.9764C40.2396 20.6207 39.9952 20.4423 39.6172 20.4423H37.1137C37.0022 20.4423 36.9021 20.4925 36.8137 20.5927C36.7244 20.6926 36.6802 20.7987 36.6802 20.9095C36.6802 20.9543 36.8971 21.6104 37.3309 22.8786C37.7647 24.1472 38.2319 25.5156 38.7326 26.9842C39.2332 28.4524 39.4945 29.2316 39.5168 29.3198C37.6922 31.8122 36.7803 33.1471 36.7803 33.3248C36.7803 33.6143 36.9247 33.7588 37.2142 33.7588H39.784C40.0286 33.7588 40.2288 33.6478 40.3848 33.4252L48.8954 21.143C48.9396 21.0989 48.9618 21.0214 48.9618 20.9094ZM32.4411 20.4424H34.9777C35.111 20.4424 35.2221 20.4982 35.3111 20.6092C35.3999 20.7206 35.4331 20.8427 35.4112 20.9763L34.0429 29.6871C33.9761 30.1102 33.7311 30.3212 33.3087 30.3212H31.0059C30.7165 30.3212 30.572 30.1437 30.572 29.7872C30.572 29.5872 30.6163 29.3535 30.7055 29.0867C30.305 29.5319 29.771 29.8877 29.1035 30.1547C28.4362 30.4214 27.7906 30.5552 27.1679 30.5552C25.8772 30.5552 24.8484 30.1663 24.0808 29.387C23.3132 28.6086 22.9293 27.5629 22.9293 26.2499C22.9293 24.6259 23.4909 23.2126 24.6146 22.0111C25.7381 20.8096 27.1011 20.2088 28.703 20.2088C30.216 20.2088 31.2729 20.6543 31.8737 21.544C31.9405 20.8096 32.1292 20.4424 32.4411 20.4424ZM28.5365 27.8517C29.3592 27.8517 30.0548 27.5798 30.6223 27.034C31.1897 26.4895 31.4733 25.8051 31.4734 24.9818C31.4734 24.3364 31.2673 23.8302 30.856 23.463C30.444 23.096 29.9267 22.9124 29.304 22.9124C28.4805 22.9124 27.7907 23.1961 27.2348 23.7635C26.6783 24.3308 26.4003 25.0267 26.4003 25.8493C26.4003 26.473 26.5949 26.9626 26.9845 27.3178C27.3735 27.674 27.8908 27.8517 28.5365 27.8517Z"
                            fill="white"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M57.0056 15.5358C58.3852 15.5358 59.5029 15.831 60.3596 16.42V16.4197C61.216 17.0095 61.6446 17.9607 61.6445 19.2734C61.6445 21.1873 61.0994 22.6834 60.0091 23.7623C58.9187 24.8418 57.4172 25.3809 55.5035 25.3809C55.4372 25.3809 55.2809 25.37 55.0362 25.3479C54.7913 25.3257 54.5802 25.3144 54.4022 25.3144C54.2238 25.3144 54.035 25.3311 53.835 25.3642C53.6345 25.3974 53.4678 25.4702 53.3343 25.5814C53.2006 25.6928 53.1227 25.8374 53.1006 26.0153L52.4998 29.8866C52.4106 30.1759 52.2327 30.3203 51.9657 30.3203H49.2291C49.0956 30.3203 48.9838 30.2649 48.8956 30.1535C48.8063 30.0423 48.7728 29.92 48.7954 29.7863L50.9648 16.1698C51.0089 15.7472 51.2539 15.5358 51.6989 15.5358H57.0056ZM54.7362 22.4106C55.7149 22.4106 56.4493 22.2439 56.9389 21.9102C57.428 21.5762 57.673 20.9424 57.673 20.0076C57.673 19.5628 57.5397 19.2233 57.2726 18.9896C57.0056 18.7561 56.727 18.6172 56.4383 18.5726C56.1486 18.5282 55.7593 18.5058 55.2698 18.5058H54.6692C54.4242 18.5058 54.2795 18.6285 54.2355 18.8729L53.6681 22.4441L54.7362 22.4106ZM78.7979 15.5358H76.3285C76.0831 15.5358 75.9386 15.6582 75.8945 15.9031L73.7252 29.7869L73.6917 29.8536C73.6917 29.9654 73.7362 30.0706 73.8254 30.1708C73.9139 30.2707 74.0257 30.3208 74.159 30.3208H76.3621C76.7841 30.3208 77.0178 30.1099 77.063 29.6868L79.2322 16.0366V16.0035C79.2321 15.6918 79.087 15.5362 78.7979 15.5362V15.5358ZM72.8918 20.4424H70.3553C70.0434 20.4424 69.855 20.8096 69.7882 21.544C69.209 20.6543 68.1529 20.2088 66.6173 20.2088C65.0154 20.2088 63.6525 20.8096 62.5291 22.0111C61.4054 23.2126 60.8438 24.6259 60.8438 26.2499C60.8438 27.5629 61.2276 28.6086 61.995 29.387C62.7626 30.1663 63.7915 30.5552 65.0825 30.5552C65.7276 30.5552 66.3839 30.4214 67.0514 30.1547C67.7188 29.8877 68.2412 29.5319 68.6202 29.0867C68.6202 29.109 68.5974 29.2088 68.5535 29.3867C68.5085 29.565 68.4866 29.699 68.4866 29.7872C68.4866 30.1437 68.6308 30.3212 68.9205 30.3212H71.2235C71.6457 30.3212 71.8908 30.1102 71.9573 29.6871L73.3258 20.9763C73.3478 20.8427 73.3145 20.7206 73.2257 20.6092C73.1362 20.4982 73.0252 20.4424 72.8918 20.4424ZM68.5365 27.0175C67.9692 27.5738 67.2849 27.8517 66.484 27.8517C65.8385 27.8517 65.3161 27.674 64.9154 27.3178C64.5147 26.9626 64.3144 26.473 64.3144 25.8493C64.3144 25.0267 64.5926 24.3308 65.1491 23.7635C65.7045 23.1961 66.3949 22.9125 67.2182 22.9125C67.8406 22.9125 68.358 23.096 68.77 23.463C69.1813 23.8302 69.3877 24.3364 69.3877 24.9818C69.3875 25.7827 69.1038 26.4615 68.5365 27.0175Z"
                            fill="#009CDE"
                          />
                          <rect
                            x="0.5"
                            y="0.5"
                            width="86"
                            height="48.7143"
                            rx="5.5"
                            stroke="black"
                            stroke-opacity="0.14"
                          />
                        </svg>
                      </div>
                      <Link
                        className="btn-logout text-white mt-3"
                        to="/dashboard/generation"
                      >
                        Back
                      </Link>
                    </li>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div role="status">
            <svg
              aria-hidden="true"
              className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
            <span className="sr-only">Loading...</span>
          </div>
        )}
      </motion.div>
    </>
  );
};
